import { useAuthStateStore } from '../../store/useAuthStateStore';
export const useJWT = () => {
    return useAuthStateStore((state) => state.jwt);
};
//# sourceMappingURL=useJWT.js.map